import React from 'react';

const ArchitectsEngineersPage = () => {
  return (
    <div>
      <h1>Architects & Engineers</h1>
    </div>
  );
};

export default ArchitectsEngineersPage;
